import React from 'react';
import Skeleton from 'react-loading-skeleton';

const AvtaleGiroProposalLinkCardSkeleton: React.FC = () => (
    <div className="sgw-content">
        <Skeleton className="sgw-link-card" height="7rem" />
    </div>
);

export default AvtaleGiroProposalLinkCardSkeleton;
